export default {
  ShowTransfer: 'ShowTransfer',
  ShowCAReceipt: 'ShowCAReceipt',
  Save: 'Save',
  SaveAdd: 'SaveAdd',
  SaveClose: 'SaveClose',
  Close: 'Close',
  Insert: 'Insert',
  Hide: 'Hide',
  Cancel: 'Cancel',
  Quit: 'Quit',
  ShowHideColumn: 'ShowHideColumn',
  // Hoãn
  Postpone: 'Postpone',
  NextVoucher: 'NextVoucher',
  BackVoucher: 'BackVoucher',
  SaveView: 'SaveView',
  Ok: 'Ok',
  Delete: 'Delete',
  All: 'All',
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Active: 'Active',
  Unactive: 'Unactive',
  Edit: 'Edit',
  Close: 'Close',
  Duplicate: 'Duplicate',
  Add: 'Add',
  View: 'View',
  Posted: 'Posted',
  UnPosted: 'UnPosted',
  Estimate: 'Estimate',
  NextStep: 'NextStep',
  BackStep: 'BackStep',
  ViewAccount: 'ViewAccount',
  AddAutoBusiness: 'AddAutoBusiness',
  GenerateData: 'GenerateData',
  ApproveAction: 'ApproveAction',
  Refresh: 'Refresh',
  ChangeStatusPosted: 'ChangeStatusPosted',
  Copy: 'Copy',
  ShowWithDrawCash: 'ShowWithDrawCash',
  ShowWithDrawDeposit: 'ShowWithDrawDeposit',
  ShowWithDrawTransfer: 'ShowWithDrawTransfer',
  ShowWithDrawSalaryTransfer: 'ShowWithDrawSalaryTransfer',
  ShowBUTreasuryFundTransferSalary: 'ShowBUTreasuryFundTransferSalary',
  ShowBUTreasuryFundTransferInsurancePayment: 'ShowBUTreasuryFundTransferInsurancePayment',
  GLVoucherDetail: 'GLVoucherDetail',
  SaveParalell: 'SaveParalell',
  ImportExcel: 'ImportExcel',
  ExportExcel: 'ExportExcel',
  FileAttach: 'FileAttach',
  ViewEnact: 'ViewEnact',
  AddEnactConfig: 'AddEnactConfig',
  Enact: 'Enact',
  AddCustom: 'AddCustom',
  DeleteCustom: 'DeleteCustom',
  CreateFromAudit: 'CreateFromAudit',
  ViewReport: 'ViewReport',
  ViewReportDemo: 'ViewReportDemo',
  ConfigColumn: 'ConfigColumn',
  Default: 'Default',
  DeleteRowGrid: 'DeleteRowGrid',
  SaveSalary: 'SaveSalary',
  Help: 'Help',
  PushToSystem: 'PushToSystem',
  ToggleViewEstimate: 'ToggleViewEstimate',  
  Recall: 'Recall',  
  ShowSettingLayout: 'ShowSettingLayout',
  Complete: 'Complete',
  SendBack: 'SendBack',
  CancelComplete: 'CancelComplete',
  Change: 'Change',
  InsertApprove: 'InsertApprove',
  MergeApprove: 'MergeApprove',
  RefuseApprove: 'RefuseApprove',
  EditAdjustment: 'EditAdjustment',
  ViewAdjustment: 'ViewAdjustment',
};
